import { render, staticRenderFns } from "./investmentFollowManage.vue?vue&type=template&id=364b147a&scoped=true&"
import script from "./investmentFollowManage.vue?vue&type=script&lang=js&"
export * from "./investmentFollowManage.vue?vue&type=script&lang=js&"
import style0 from "./investmentFollowManage.vue?vue&type=style&index=0&id=364b147a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364b147a",
  null
  
)

export default component.exports